// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2zdL3","info":"Note_info__m9TjU","note":"Note_note__2AD_y","actions":"Note_actions__3eHl_"};